// eslint-disable-next-line no-shadow
export enum HiringScreens {
  OnboardingPhases = 'OnboardingPhases',
  ApplicationStatus = 'ApplicationStatus',
}
